import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconBefore", "iconAfter", "renderAs"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { focusStyle, activeStyle, hoverStyle, addIcon, extendedSystemStyles } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];

/* eslint-disable */
var SecondaryButton = styled( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter,
    renderAs = _ref.renderAs,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(NavLink, _objectSpread({
    as: renderAs,
    ref: ref
  }, rest));
})).withConfig({
  displayName: "SecondaryButtonLink__SecondaryButton",
  componentId: "sc-jozxd0-0"
})(["&:before{", "}&:after{", "}", " ", ""], function (_ref2) {
  var theme = _ref2.theme,
    iconBefore = _ref2.iconBefore;
  return iconBefore ? addIcon(theme, iconBefore, "auto 10px auto 0") : "";
}, function (_ref3) {
  var theme = _ref3.theme,
    iconAfter = _ref3.iconAfter;
  return iconAfter ? addIcon(theme, iconAfter, "auto 0 auto 10px") : "";
}, function (_ref4) {
  var theme = _ref4.theme,
    active = _ref4.active,
    disabled = _ref4.disabled;
  return "\n      height: ".concat(theme.actionStyles.height, ";\n      font-family: ").concat(theme.fonts.robotoRegular, ";\n      font-size: ").concat(theme.fontSizes[theme.actionStyles.fontSize], ";\n      line-height: ").concat(theme.actionStyles.height, ";\n\n      display: flex;\n      justify-content: center;\n\n      width: 210px;\n      padding: 0;\n      border-radius: ").concat(theme.actionStyles.buttonRadius, ";\n      box-shadow: ").concat(disabled ? "inset 0 0 0 3px ".concat(theme.colors.P2, "a8") : "inset 0 0 0 3px ".concat(theme.colors.P2), ";\n\n      background: ").concat(theme.colors.G1, ";\n      color: ").concat(!disabled ? theme.colors.P0 : "".concat(theme.colors.P0, "a8"), ";\n\n      outline: none;\n      border: none;\n      transition: all .3s;\n\n      ").concat(!active && !disabled ? "\n        &:hover{ ".concat(hoverStyle(theme), " }\n        &:focus{ ").concat(focusStyle(theme), " }\n      ") : "", "\n\n      ").concat(active ? activeStyle(theme) : "");
}, extendedSystemStyles(styledSystemKeys));
SecondaryButton.propTypes = {
  id: PropTypes.string,
  to: PropTypes.any.isRequired,
  className: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool
};
export default SecondaryButton;